import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import {
    NavigationCancel,
    ResolveEnd,
    ResolveStart,
    Router,
    RouterOutlet
} from '@angular/router';

import { concat, filter, map, of } from 'rxjs';

import { CmsService } from './cms';
import { FooterComponent, NavbarComponent } from './shared';

@Component({
    selector: 'kc-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [NavbarComponent, RouterOutlet, FooterComponent, AsyncPipe]
})
export class AppComponent {
    private router = inject(Router);
    private cms = inject(CmsService);

    public isLoading = concat(of(false), concat(this.router.events)).pipe(
        filter(
            e =>
                e instanceof ResolveStart ||
                e instanceof ResolveEnd ||
                e instanceof NavigationCancel
        ),
        map(e => (e instanceof ResolveStart ? true : false))
    );

    public navBarLinks = this.cms.getNavBarLinks();

    public footerTitle = this.cms.getContactTitle();

    @HostBinding('class')
    public hostClasses = `
        grid grid-rows-[auto_auto_1fr_auto] grid-cols-[min-content]
        auto-cols-[0] md:auto-cols-[1fr]
        justify-center justify-items-stretch items-stretch
        min-h-screen md:h-screen
        bg-white
        font-serif
    `;
}
